var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 20.1667C5.93717 20.1667 1.83325 16.0628 1.83325 11C1.83325 5.93729 5.93717 1.83337 10.9999 1.83337C16.0627 1.83337 20.1666 5.93729 20.1666 11C20.1666 16.0628 16.0627 20.1667 10.9999 20.1667ZM10.9999 9.70387L8.40759 7.11062L7.1105 8.40771L9.70375 11L7.1105 13.5924L8.40759 14.8895L10.9999 12.2962L13.5923 14.8895L14.8893 13.5924L12.2961 11L14.8893 8.40771L13.5923 7.11062L10.9999 9.70387Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.e6251946e46b5610ef5cb70a0b2b73ad.svg";
export { ForwardRef as ReactComponent };